export const PI2 = Math.PI * 2;
export const HUE = 273;
export const FADE_SPEED = 6;
export const MIN_POINTS = 6;
export const DRAW_TIME = 1000;
